import { render } from "./BookingConfirmed.vue?vue&type=template&id=dea47374&scoped=true"
import script from "./BookingConfirmed.vue?vue&type=script&lang=js"
export * from "./BookingConfirmed.vue?vue&type=script&lang=js"

import "./BookingConfirmed.vue?vue&type=style&index=0&id=dea47374&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dea47374"]])

export default __exports__